<template>
  <div class="filter-card-wrapper">
    <div class="filter-card-wrapper__header" @click="onCardToggle">
      <div class="rich-text">
        <p>
          <strong>{{ title }}</strong>
        </p>
      </div>
      <slot name="radiowrapper"></slot>
      <icon
        v-if="!hasRadio"
        :name="expanded ? 'chevron-up' : 'chevron-down'"
        class-name="filter-card-wrapper__header--chevron_icon"
        size="24" />
    </div>
    <div v-if="expanded" class="filter-card-wrapper__body">
      <slot name="header"></slot>
      <slot name="body"></slot>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
// Maersk Icons

export default {
  name: "FilterCardWrapper",
  props: {
    title: { type: String, required: true },
    hasRadio: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false },
  },
  methods: {
    onCardToggle() {
      this.$parent.$listeners.onCardToggle(this.title);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-card-wrapper {
  background-color: var(--Gray-50);
  margin: 8px 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px;
  & .filter-card-wrapper__header {
    display: flex;
    flex: 1;
    justify-content: space-between;
    cursor: pointer;
    & .rich-text > p {
      color: var(--Blue-900-Darkest);
    }
    & .filter-card-wrapper__header--chevron_icon {
      color: var(--Blue-900-Darkest);
    }
  }
}
</style>
